export default __webpack_public_path__ + "static/media/adventurespejd.e81102ff.png";